import { useContext, useEffect, useReducer } from 'react';
import { ChromeContext } from '../ChromeContext';
import { UpdateEvents } from '../ChromeProvider';
var useLastVisited = function () {
    var _a;
    var _b = useContext(ChromeContext), subscribe = _b.subscribe, unsubscribe = _b.unsubscribe, getState = _b.getState;
    var _c = useReducer(function (count) { return count + 1; }, 0), forceRender = _c[1];
    useEffect(function () {
        var subsId = subscribe(UpdateEvents.lastVisited, forceRender);
        return function () {
            unsubscribe(subsId, UpdateEvents.lastVisited);
        };
    }, []);
    return (_a = getState().lastVisitedPages) !== null && _a !== void 0 ? _a : [];
};
export default useLastVisited;
//# sourceMappingURL=useLastVisited.js.map